import React, { PureComponent } from 'react'

import Ratio from 'components/Ratio'

import { Helpers } from 'api'

// import urlHelper from 'url'

import urlJoin from 'url-join'

export default class Img extends PureComponent {
    render() {
        const { src = "", statics = false, externals = false, byWidget = false, tag = true, div = false, ...other } = this.props

        const { image_path/*, static_path*/ } = window

        let url = src

        if( statics )
        {
            // url = urlJoin( static_path, url )
        }

        if( externals )
        {
            url = urlJoin( image_path, url )
        }

        if( byWidget )
        {
            url = urlJoin( image_path, Helpers.GetImage( src ) )
        }

        if( !tag || div )
        {
            return (
                <div className="image" style={{ backgroundImage: `url(${url})` }} { ...other }/>
            )
        }

        return (
            <img src={ url } alt="" { ...other }/>
        )
    }
}

const ImgRatio = ({ ratio = 1, ...props }) => (
   <Ratio value={ ratio }>
        <Img { ...props } />
    </Ratio>
)

export { ImgRatio }